import { render, staticRenderFns } from "./AdministrationOffersLayout.vue?vue&type=template&id=34a8d29f&"
import script from "./AdministrationOffersLayout.vue?vue&type=script&lang=ts&"
export * from "./AdministrationOffersLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports